module.exports = __webpack_public_path__ + "img/img_baby_light_off.4de8fb16.png";